export default __webpack_public_path__ + "static/media/ekoios_token.aa690f5e.svg";